// src/i18n.js
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en/translation.json'
import fi from './locales/fi/translation.json'

const resources = {
  en: { translation: en },
  fi: { translation: fi },
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    // Look at window.location.pathname (“/fi” → “fi”), or fall back to 'en'
    lng: window.location.pathname.split('/')[1] || 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  })

export default i18n
